import { DEFAULT_CATALOG_STRUCTURE } from './constants';

export const getCatalogs = state => state.admin.catalogs;
export const getCatalogsData = state => getCatalogs(state).data;
export const getCatalogsCount = state => getCatalogs(state)?.totalCatalogs;
export const getCatalogProductsCount = state => getCatalogs(state)?.totalProducts;
export const getCatalogById = (state, catalogId) => getCatalogsData(state)[catalogId] || DEFAULT_CATALOG_STRUCTURE;
export const getCatalogProducts = (state, catalogId) => getCatalogById(state, catalogId).products;
export const getCatalogStatus = (state, catalogId) => getCatalogById(state, catalogId).status;
export const getCatalogOrderTypes = (state, catalogId) => getCatalogById(state, catalogId).orderTypes;
export const getSeasons = state => getCatalogs(state).seasons;
export const getFindProductForm = state => getCatalogs(state).findProductForm;
